import React from 'react';
import { Configure, ConfigureProps, InstantSearch } from 'react-instantsearch';
import { useUser, useAlgolia } from '../../../../hooks';
import { Company, Plan, ShopItem, User, Variant } from '../../../../models';
import SelectEmployee from './SelectEmployee';
import EmployeeRow from './EmployeeRow';
import Alert from '../../Alert/Alert';

interface EmployeeListProps {
  shopList: ShopItem[];
  setShopList: React.Dispatch<React.SetStateAction<ShopItem[]>>;
  variant?: Variant;
  type: 'product' | 'plan' | 'benefit';
  plans?: Plan[];
  benefitValue?: number;
}

function EmployeeList({
  shopList,
  setShopList,
  variant,
  type,
  plans,
  benefitValue,
}: EmployeeListProps) {
  const [user] = useUser();

  const [searchText, setSearchText] = React.useState('');

  const { searchClient } = useAlgolia();

  const configureProps = {
    ruleContexts: [],
    facetFilters: [
      [`active:true`],
      ['userType:client'],
      [`company._id:${(user.company as Company)._id}`],
    ],
  } as any;

  return (
    <div className="w-full flex flex-col">
      <h3 className="text-purple-300 text-lg font-semibold mb-4">
        Lista de beneficiarios
      </h3>
      <div className="w-full flex sm:h-80 flex-col sm:flex-row">
        <div className=" order-2 sm:order-1 w-full md:w-1/2 flex flex-col pr-4 sm:border-r sm:border-system-500 mt-5 sm:mt-0">
          <InstantSearch
            indexName="users"
            searchClient={searchClient}
            insights
            routing
          >
            <SelectEmployee
              setSearchText={setSearchText}
              searchText={searchText}
              shopList={shopList}
              setShopList={setShopList}
              productType={type}
              plans={plans}
              benefitValue={benefitValue}
            />
            <Configure {...(configureProps as ConfigureProps)} />
          </InstantSearch>
        </div>
        <div className=" order-1 sm:order-2 w-full md:w-1/2 flex flex-col sm:pl-8 ">
          {shopList?.length > 0 ? (
            <section className="overflow-y-auto max-h-80">
              {shopList?.map(({ client, price: value }, i) => (
                <EmployeeRow
                  key={`${(client as User)?._id}-${i}`}
                  user={client as User}
                  type={type}
                  price={type === 'product' ? variant?.price : value}
                  shopList={shopList}
                  setShopList={setShopList}
                />
              ))}
            </section>
          ) : (
            <div className="w-full">
              <Alert
                title="Agregue beneficiarios"
                text="Selecione los beneficiarios que desea otorgarles el beneficio"
                show
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default EmployeeList;
